import React, { createContext, useContext, useState, ReactNode } from "react";
import { ICart, ICartProduct } from "../classes/interfaces";
import { getCart, saveCart, emptyCartKeepingContext } from "../services/cartService";

interface CartContextValue {
  cart: ICart;
  setCart: (cart: ICart) => void;
  addProduct: (product: ICartProduct) => void;
  clearCart: () => void;
}

const CartContext = createContext<CartContextValue | undefined>(undefined);

export function CartProvider({ children }: { children: ReactNode }) {
  const [cart, setCartState] = useState<ICart>(() => getCart());

  function setCart(next: ICart) {
    saveCart(next);
    setCartState(next);
  }

  function addProduct(product: ICartProduct) {
    setCartState((prevCart) => {
      const next: ICart = {
        ...prevCart,
        grouping_last: prevCart.grouping_last + 1,
        product_last: prevCart.product_last + 1,
        products: [...prevCart.products, product],
        total: prevCart.total + product.total,
      };
      saveCart(next);
      return next;
    });
  }

  function clearCart() {
    setCartState((prevCart) => saveCart(emptyCartKeepingContext(prevCart)));
  }

  return (
    <CartContext.Provider value={{ cart, setCart, addProduct, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart(): CartContextValue {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
}
